import { type GlobalMessageHandler } from '@atlassian/eoc-global-context';

import { type AlertDetailMessage } from './types';

export type DynamicItem = {
	value: string;
	label: string;
	icon: React.ReactNode;
	description: string;
	tier: number;
};
type QueryDynamicItemsByName = (query: string) => Promise<DynamicItem[] | void>;
type QueryDynamicItemsById = (query: string[]) => Promise<DynamicItem[] | void>;

export type DynamicDetailView = {
	label: React.ReactNode;
	addADynamicObjectText: string;
	foldedDisplayText: React.ReactNode;
	alertGroupingStateResource: any;
	queryDynamicItemsByName: QueryDynamicItemsByName;
	queryDynamicItemsById: QueryDynamicItemsById;
};

export class AlertDetailHandler implements GlobalMessageHandler<unknown> {
	handler(
		message: AlertDetailMessage,
		context?: any,
	): { [key: string]: DynamicDetailView } | void | any {
		throw new Error('Not implemented');
	}
}
